import "./ImageGrid.scss";
import { useNavigate } from "react-router-dom";

const ImageGrid = () => {
  const images = [
    {
      src: "/images/category/image1.png",
      gridArea: "a",
      title: "SACS & DÉCHETS",
      key: "01",
    },
    {
      src: "/images/category/image2.png",
      gridArea: "b",
      title: "OUATE & PAPIER",
      key: "02",
    },
    {
      src: "/images/category/image3.png",
      gridArea: "c",
      title: "PRODUITS D'ENTRETIEN",
      key: "04",
    },
    {
      src: "/images/category/image4.png",
      gridArea: "d",
      title: "VITRERIE",
      key: "06",
    },
    {
      src: "/images/category/image5.png",
      gridArea: "e",
      title: "PETIT MATÉRIEL",
      key: "05",
    },
    {
      src: "/images/category/image6.png",
      gridArea: "f",
      title: "MATÉRIELS & CHARIOTS",
      key: "09",
    },
    {
      src: "/images/category/image7.png",
      gridArea: "g",
      title: "EPI",
      key: "08",
    },
    {
      src: "/images/category/image8.png",
      gridArea: "h",
      title: "CHR",
      key: "03",
    },
    {
      src: "/images/category/image9.png",
      gridArea: "i",
      title: "AMPOULES",
      key: "07",
    },
  ];

  const navigate = useNavigate();

  return (
    <div className="image-grid">
      {images.map((image, index) => (
        <div
          key={index}
          className={`image-item ${image.gridArea}`}
          onClick={() => navigate(`/category-product/${image.key}`)}
        >
          <a href={`/category-product/${image.key}`}>
            <div>
              <p>{image.title}</p>
            </div>
          </a>
          <img src={image.src} alt={`image-${index}`} />
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
